import axiosAuth from "../../axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface UseGetQualityCheckUpdatesProps {
  projectId: string;
  taskId: string;
  checkId: string;
  includePresignedUrls?: boolean;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getQualityCheckUpdates = async (taskId: string, projectId: string, checkId: string, includePresignedUrls: boolean = true) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/tasks/${taskId}/quality-checks/${checkId}/updates${includePresignedUrls ? `?includePresignedUrls=${includePresignedUrls}` : ''}`);

const useGetQualityCheckUpdates = ({
  taskId,
  projectId,
  checkId,
  includePresignedUrls = true,
  queryParams,
}: UseGetQualityCheckUpdatesProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["quality-checks-updates", checkId],
    queryFn: () => getQualityCheckUpdates(taskId, projectId, checkId, includePresignedUrls),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetQualityCheckUpdates;
